(function() {
      // ------------------------------------------------------------------------
      // Interactive Carousel Engine (5 Slides)
      // ------------------------------------------------------------------------
      const slides = document.querySelectorAll('.pdp-carousel__slide');
      const thumbs = document.querySelectorAll('.pdp-gallery__thumb');
      const dots = document.querySelectorAll('.pdp-carousel__dot');
      const badge = document.getElementById('carousel-badge');
      const counter = document.getElementById('carousel-counter');
      const prevBtn = document.getElementById('carousel-prev');
      const nextBtn = document.getElementById('carousel-next');
      const stage = document.getElementById('carousel-stage');

      let currentIndex = 0;
      const totalSlides = slides.length;

      function goToSlide(index) {
        if (index < 0) {
          currentIndex = totalSlides - 1;
        } else if (index >= totalSlides) {
          currentIndex = 0;
        } else {
          currentIndex = index;
        }

        // Update slides
        slides.forEach((slide, i) => {
          if (i === currentIndex) {
            slide.classList.add('is-active');
            const badgeText = slide.getAttribute('data-badge');
            if (badge && badgeText) badge.textContent = badgeText;
          } else {
            slide.classList.remove('is-active');
          }
        });

        // Update thumbnails
        thumbs.forEach((thumb, i) => {
          if (i === currentIndex) {
            thumb.classList.add('is-active');
            thumb.setAttribute('aria-selected', 'true');
          } else {
            thumb.classList.remove('is-active');
            thumb.setAttribute('aria-selected', 'false');
          }
        });

        // Update dots
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === currentIndex);
        });

        // Update counter
        if (counter) {
          counter.textContent = `${currentIndex + 1} / ${totalSlides}`;
        }
      }

      // Prev / Next button clicks
      if (prevBtn) prevBtn.addEventListener('click', () => goToSlide(currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => goToSlide(currentIndex + 1));

      // Thumbnail clicks & keyboard accessibility
      thumbs.forEach((thumb, idx) => {
        thumb.addEventListener('click', () => goToSlide(idx));
        thumb.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            goToSlide(idx);
          }
        });
      });

      // Dot clicks
      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => goToSlide(idx));
      });

      // Keyboard arrow navigation on stage
      stage.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          goToSlide(currentIndex - 1);
        } else if (e.key === 'ArrowRight') {
          goToSlide(currentIndex + 1);
        }
      });

      // Mobile Touch Swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      stage.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      stage.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });

      function handleSwipe() {
        const threshold = 40;
        if (touchEndX < touchStartX - threshold) {
          goToSlide(currentIndex + 1); // Swipe left -> next
        } else if (touchEndX > touchStartX + threshold) {
          goToSlide(currentIndex - 1); // Swipe right -> prev
        }
      }

      // ------------------------------------------------------------------------
      // Pack Selection
      // ------------------------------------------------------------------------
      // Packs → Shopify cart permalink: /cart/<variant>:<qty>?discount=<code>
      // The free bottles are made $0 by the Shopify discount code of each pack.
      const packWrap = document.querySelector('.pdp-packs');
      const packs = Array.from(document.querySelectorAll('.pdp-pack'));
      const btnAddCart = document.getElementById('btn-add-to-cart');
      const checkoutNote = document.getElementById('checkout-note');
      const stickyPackName = document.getElementById('sticky-pack-name');
      const stickyPrice = document.getElementById('sticky-price');
      const btnStickyBuy = document.getElementById('btn-sticky-buy');
      const variantId = packWrap ? packWrap.dataset.variantId : '';
      const cartUrl = (packWrap && packWrap.dataset.cartUrl) || '/cart';
      const available = packWrap && packWrap.dataset.available === 'true';

      let selected = document.querySelector('.pdp-pack.is-selected') || packs[0];

      function packInfo(pack) {
        return {
          qty: parseInt(pack.dataset.qty, 10),
          price: pack.dataset.priceLabel,
          code: (pack.dataset.code || '').trim(),
          name: pack.dataset.name
        };
      }

      function selectPack(pack) {
        packs.forEach(p => {
          const on = p === pack;
          p.classList.toggle('is-selected', on);
          p.setAttribute('aria-checked', on ? 'true' : 'false');
          p.tabIndex = on ? 0 : -1;
        });
        selected = pack;
        const info = packInfo(pack);
        const units = info.qty === 1 ? '1 bottle' : info.qty + ' bottles';
        if (available) btnAddCart.textContent = 'Add to Bag — ' + info.price;
        if (stickyPackName) stickyPackName.textContent = info.qty === 1 ? info.name : info.name + ' · ' + units;
        if (stickyPrice) stickyPrice.textContent = info.price;
        if (checkoutNote) checkoutNote.hidden = true;
      }

      packs.forEach((pack, i) => {
        pack.addEventListener('click', () => selectPack(pack));
        pack.addEventListener('keydown', e => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            selectPack(pack);
          } else if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].includes(e.key)) {
            e.preventDefault();
            const step = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
            const next = packs[(i + step + packs.length) % packs.length];
            selectPack(next);
            next.focus();
          }
        });
      });

      function checkoutUrl(info) {
        let url = cartUrl.replace(/\/$/, '') + '/' + variantId + ':' + info.qty;
        if (info.code) url += '?discount=' + encodeURIComponent(info.code);
        return url;
      }

      if (btnAddCart) btnAddCart.addEventListener('click', function() {
        if (!selected) return;
        const info = packInfo(selected);
        if (!variantId || !available) {
          checkoutNote.textContent = variantId
            ? 'This product is currently sold out.'
            : 'No product is linked to this page yet — no order has been placed.';
          checkoutNote.hidden = false;
          return;
        }
        btnAddCart.disabled = true;
        window.location.href = checkoutUrl(info);
      });

      // ------------------------------------------------------------------------
      // Sticky Buy Bar Scroll Trigger
      // ------------------------------------------------------------------------
      const stickyBar = document.getElementById('sticky-bar');
      const packsSection = document.getElementById('packs');

      window.addEventListener('scroll', function() {
        if (!packsSection) return;
        const rect = packsSection.getBoundingClientRect();
        if (rect.bottom < 0) {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        } else {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        }
      }, { passive: true });

      btnStickyBuy.addEventListener('click', function() {
        btnAddCart.click();
      });


      // ------------------------------------------------------------------------
      // Accordions
      // ------------------------------------------------------------------------
      const accordions = document.querySelectorAll('.pdp-accordion__header, .faq-question');
      accordions.forEach(header => {
        header.addEventListener('click', function() {
          const parent = this.parentElement;
          const isOpen = parent.classList.contains('is-open');
          
          if (isOpen) {
            parent.classList.remove('is-open');
          } else {
            parent.classList.add('is-open');
          }
        });
      });


      // ------------------------------------------------------------------------
      // Customer photos lightbox
      // ------------------------------------------------------------------------
      const lightbox = document.getElementById('review-lightbox');
      if (lightbox && lightbox.showModal) {
        const lightboxImg = lightbox.querySelector('img');
        document.querySelectorAll('.review-card__photo').forEach(btn => {
          btn.addEventListener('click', () => {
            const img = btn.querySelector('img');
            lightboxImg.src = img.currentSrc || img.src;
            lightboxImg.alt = img.alt;
            lightbox.showModal();
          });
        });
        lightbox.querySelector('.review-lightbox__close').addEventListener('click', () => lightbox.close());
        lightbox.addEventListener('click', e => { if (e.target === lightbox) lightbox.close(); });
      }
    })();
